import React, { useState } from 'react';
import {
  Box,
  IconButton,
  Typography,
  DialogTitle,
  Dialog,
} from '@mui/material';
import {
  Close,
  ZoomIn,
  ZoomOut,
  RotateLeft,
  RotateRight,
} from '@mui/icons-material';

function ImageViewer({ file, onClose }) {
  const [scale, setScale] = useState(1.0);
  const [rotation, setRotation] = useState(0);

  const changeScale = (offset) => {
    setScale((prevScale) => {
      const newScale = prevScale + offset;
      return Math.min(Math.max(0.1, newScale), 5.0);
    });
  };

  const changeRotation = (offset) => {
    setRotation((prevRotation) => (prevRotation + offset) % 360);
  };

  return (
    <>
      <div className="flex justify-between items-center">
        <DialogTitle>圖片預覽</DialogTitle>
        <IconButton className="mr-4" onClick={onClose} color="error">
          <Close />
        </IconButton>
      </div>

      {/* 控制按鈕 */}
      <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2, gap: 1 }}>
        <IconButton
          onClick={() => changeScale(-0.2)}
          disabled={scale <= 0.1}
          size="small"
        >
          <ZoomOut />
        </IconButton>
        <Typography variant="body2" sx={{ alignSelf: 'center' }}>
          {Math.round(scale * 100)}%
        </Typography>
        <IconButton
          onClick={() => changeScale(0.2)}
          disabled={scale >= 5.0}
          size="small"
        >
          <ZoomIn />
        </IconButton>
        <IconButton onClick={() => changeRotation(-90)} size="small">
          <RotateLeft />
        </IconButton>
        <IconButton onClick={() => changeRotation(90)} size="small">
          <RotateRight />
        </IconButton>
      </Box>

      {/* 圖片容器 */}
      <Box
        sx={{
          width: '100%',
          height: 'calc(100% - 120px)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          overflow: 'auto',
          backgroundColor: '#f5f5f5',
        }}
      >
        <img
          src={file}
          alt="預覽圖片"
          style={{
            maxWidth: '100%',
            maxHeight: '100%',
            transform: `scale(${scale}) rotate(${rotation}deg)`,
            transition: 'transform 0.2s ease-in-out',
          }}
        />
      </Box>
    </>
  );
}
const ImageViewerDialog = ({ open, file, onClose }) => {
  return (
    <Dialog
      fullWidth
      maxWidth={false}
      classes={{ paper: 'h-full' }}
      open={open}
    >
      <ImageViewer file={file} onClose={onClose} />
    </Dialog>
  );
};
export default ImageViewerDialog;
